import { apiGet, apiPost } from "./http";

export interface PlatformOperationLogDto {
  id: string;
  timestamp: string;
  operator: string;
  operatorRole: string;
  actionType: string;
  targetTenant: string;
  targetTenantCode: string;
  detail: string;
  ip: string;
  result: string;
}

export function fetchPlatformOperationLogs(take = 300) {
  return apiGet<PlatformOperationLogDto[]>(`/api/platform/operation-logs?take=${take}`);
}

export function postPlatformClientOperationLog(body: {
  actionType: "impersonate" | "view" | "login" | "logout";
  detail: string;
  targetTenant?: string;
  targetTenantCode?: string;
  operator?: string;
  operatorRole?: string;
  ip?: string;
  result?: "success" | "warning" | "failed";
}) {
  return apiPost<PlatformOperationLogDto>("/api/platform/operation-logs", {
    actionType: body.actionType,
    detail: body.detail,
    targetTenant: body.targetTenant,
    targetTenantCode: body.targetTenantCode,
    operator: body.operator,
    operatorRole: body.operatorRole,
    ip: body.ip,
    result: body.result ?? "success",
  });
}
